if (typeof window !== "undefined" && typeof window.fetch === "function") {
  window.fetch = window.fetch.bind(window);
}